export enum ProgressionEnum {
  PROGRESSION_1000 = "PROGRESSION_1000",
  PROGRESSION_225 = "PROGRESSION_225",
  PROGRESSION_OHNE = "PROGRESSION_OHNE",
}
